export default __webpack_public_path__ + "media/images/landing-27-550x420-1436e10b70017efbc9e03820d4219483.jpg";